import { Table } from "../../../features/Table";
import { type A9Issuer, issuers_columns } from "./columns";
import { type FilterA9IssuersSchema, FilterA9Issuers } from "./filter";
import { useTranslation } from "react-i18next";

const client = "a9";
const table_name = "a9_issuers";

export const A9IssuersTable = () => {
  const { t } = useTranslation(["tables"]);
  return (
    <Table<A9Issuer, FilterA9IssuersSchema>
      label={t(`${table_name}.title`, { defaultValue: "Issuers" })}
      client={client}
      table_name={table_name}
      columns={issuers_columns}
      filter={<FilterA9Issuers />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
